import { Box } from "@mui/material"
import type { FC } from "react"

import type { SoftReceivedLotReference } from "../types"

import { ConfirmationDialog } from "@/components/common/Modals"

interface InvalidSoftReceivedLotNumbersConfirmationDialogProps {
  invalidLots: SoftReceivedLotReference[]
  onClose: () => void
  onConfirm: () => void
}

export const InvalidSoftReceivedLotNumbersConfirmationDialog: FC<
  InvalidSoftReceivedLotNumbersConfirmationDialogProps
> = ({ invalidLots, onClose, onConfirm }) => (
  <ConfirmationDialog
    title='Lot Numbers Not Found'
    content={
      <Box>
        <p className='mb-4'>The following Lot Numbers were not found in Product Test Results:</p>
        <ul className='list-disc px-4 text-left font-normal'>
          {invalidLots.map((lot, index) => (
            <li key={`${lot.product.productId}-${lot.lotNumber}-${index}`} data-testid='invalid-lot'>
              Lot #<b>{lot.lotNumber}</b>
              {lot.batchNumber && (
                <>
                  , Batch #<b>{lot.batchNumber}</b>
                </>
              )}{" "}
              for <b>{lot.product.companyProductDescription}</b> - PO # <b>{lot.purchaseOrderId}</b>
            </li>
          ))}
        </ul>
      </Box>
    }
    closeLabel='Cancel'
    confirmLabel='Continue Anyway'
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
